import React from 'react'

import OnboardingTooltip, {
  OnboardingTooltipMessage,
  OnboardingTooltipProps,
} from 'tripPlanner/Tripkit/Onboarding/OnboardingTooltip'

const SAVE_TRIP_ONBOARDING_MESSAGES: OnboardingTooltipMessage[] = [
  {
    title: 'Save this trip',
    content:
      'Like the look of this trip? You can start planning your own by either saving the entire trip or individual items below',
  },
]

type Props = Omit<OnboardingTooltipProps, 'messages'>

export default function SaveButtonOnboardingTooltip(props: Props) {
  return (
    <OnboardingTooltip
      {...props}
      skipLabel="Got it, thanks"
      hideDismiss
      messages={SAVE_TRIP_ONBOARDING_MESSAGES}
    />
  )
}
